import React from "react";

import { Icon, IconProps } from "@chakra-ui/react";

import {
  IoArrowDownCircle,
  IoArrowUpCircle,
  IoCalendarOutline,
  IoChevronBack,
  IoChevronDown,
  IoChevronDownOutline,
  IoChevronForward,
  IoClose,
  IoCloseCircle,
  IoCopyOutline,
  IoDownloadOutline,
  IoFilter,
  IoInformationCircle,
  IoLogOutOutline,
  IoSearchOutline,
  IoWarningOutline,
} from "react-icons/io5";
import { MdSort } from "react-icons/md";
import { CgLoadbarSound } from "react-icons/cg";
import { BiSort } from "react-icons/bi";

export const iconSize = 5;

export const iconSpacing = 2;

export const ChevronBackArrow = (
  props: Omit<Partial<IconProps>, "css">
): React.ReactElement => (
  <Icon as={IoChevronBack} boxSize={3} color={props.color} {...props} />
);
export const CircledUpArrowIcon = (
  props: Omit<Partial<IconProps>, "css">
): React.ReactElement => (
  <Icon as={IoArrowUpCircle} boxSize={iconSize} color="grey.400" {...props} />
);
export const WarningIcon = (
  props: Omit<Partial<IconProps>, "css">
): React.ReactElement => (
  <Icon as={IoWarningOutline} boxSize={4} color="warningRed" {...props} />
);

export const SortIcon = (
  props: Omit<Partial<IconProps>, "css">
): React.ReactElement => <Icon as={BiSort} boxSize={iconSize} {...props} />;

export const ChevronDown = (
  props: Omit<Partial<IconProps>, "css">
): React.ReactElement => (
  <Icon as={IoChevronDownOutline} boxSize={iconSize} {...props} />
);

export const ChevronForward = (
  props: Omit<Partial<IconProps>, "css">
): React.ReactElement => (
  <Icon as={IoChevronForward} boxSize={iconSize} {...props} />
);

export const ChevronBack = (
  props: Omit<Partial<IconProps>, "css">
): React.ReactElement => (
  <Icon as={IoChevronBack} boxSize={iconSize} {...props} />
);

export const DownloadIcon = (
  props: Omit<Partial<IconProps>, "css">
): React.ReactElement => <Icon as={IoDownloadOutline} boxSize={4} {...props} />;

export const CircledDownArrowIcon = (
  props: Omit<Partial<IconProps>, "css">
): React.ReactElement => (
  <Icon as={IoArrowDownCircle} boxSize={iconSize} {...props} />
);

export const CloseIcon = (
  props: Omit<Partial<IconProps>, "css">
): React.ReactElement => <Icon as={IoClose} boxSize={iconSize} {...props} />;

export const CircledCloseIcon = (
  props: Omit<Partial<IconProps>, "css">
): React.ReactElement => (
  <Icon as={IoCloseCircle} boxSize={iconSize} {...props} />
);

export const FilterIcon = (
  props: Omit<Partial<IconProps>, "css">
): React.ReactElement => (
  <Icon as={IoFilter} boxSize={iconSize} color="grey.600" {...props} />
);

export const CopyIcon = (
  props: Omit<Partial<IconProps>, "css">
): React.ReactElement => (
  <Icon as={IoCopyOutline} boxSize={iconSize} {...props} />
);

export const CircledInfoIcon = (
  props: Omit<Partial<IconProps>, "css">
): React.ReactElement => (
  <Icon as={IoInformationCircle} boxSize={4} color="grey.500" {...props} />
);

export const ChevronDownIcon = (
  props: Omit<Partial<IconProps>, "css">
): React.ReactElement => (
  <Icon as={IoChevronDown} boxSize={4} color="grey.900" {...props} />
);
export const LogoutIcon = (
  props: Omit<Partial<IconProps>, "css">
): React.ReactElement => (
  <Icon as={IoLogOutOutline} boxSize={iconSize} {...props} />
);
export const CalendarIcon = (
  props: Omit<Partial<IconProps>, "css">
): React.ReactElement => (
  <Icon as={IoCalendarOutline} boxSize={4} color="grey.500" {...props} />
);

export const SearchIcon = (
  props: Omit<Partial<IconProps>, "css">
): React.ReactElement => (
  <Icon as={IoSearchOutline} boxSize={6} color="grey.500" {...props} />
);

export const SortAscIcon = (
  props: Omit<Partial<IconProps>, "css">
): React.ReactElement => (
  <Icon
    as={MdSort}
    boxSize={iconSize}
    color="grey.500"
    {...props}
    transform="rotate(0.5turn) scaleX(-1)"
  />
);

export const SortDescIcon = (
  props: Omit<Partial<IconProps>, "css">
): React.ReactElement => (
  <Icon as={MdSort} boxSize={iconSize} color="grey.500" {...props} />
);

export const SortNoneIcon = (
  props: Omit<Partial<IconProps>, "css">
): React.ReactElement => (
  <Icon
    as={CgLoadbarSound}
    boxSize={
      iconSize +
      1 /* This icon doesn't match the size of the other sort icons so manually make it a bit bigger*/
    }
    color="grey.500"
    {...props}
    transform="rotate(0.25turn)"
  />
);
